@ -0,0 +1,145 @@
<script>
// 根据传入的元素动态生成骨架屏
export default {
  props: {
    // 加载数据类型 list object
    loadType: {
      type: String,
      default: 'list'
    },
    // 真实加载的数据
    actualData: {
      type: [Array, Object]
    },
    // 加载状态 true 加载中 false 加载完成 more 加载更多中
    loading: {
      type: [Boolean, String],
      default: true
    },
    // 初始数据，可能需要取嵌套的对象，在里面定义一下
    itemData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 初始默认渲染几个元素
    number: {
      type: Number,
      default: 6
    }
  },
  data() {
    return {
      // slot里传入的组件节点
      componentsNode: {},
      vNode: null,
      hasComponentsRender: false, // 存在需要渲染的组件
      renderComponents: false,
      nowRenderContent: null
    }
  },
  render: function (createElement) {
    let renderContent = []
    // 无数据时生成骨架屏
    if (this.loading && this.loading !== 'more') {
      // 组件节点再次渲染
      if (this.vNode) {
        renderContent = Array.from({ length: this.number }, () => this.vNode)
        return createElement(
          'div', // 标签名称
          [createElement('div', [...renderContent])]
        )
      }
      // 创建虚拟节点
      const vNodeList = this.$scopedSlots.default({
        item: this.itemData
      })
      // 修改虚拟节点为骨架屏样式
      const vNode = this.handleTreeNodeStyle(vNodeList[0])
      // 根据传入判断需要一屏需要展示几个，复制
      renderContent = Array.from({ length: this.number }, () => vNode)
      this.$nextTick(() => {
        // 判断是否有需要重新渲染的组件节点
        if (Object.keys(this.componentsNode).length > 0) {
          const newNode = this.handleComponentsNodes(vNode)
          this.$nextTick(() => {
            this.vNode = newNode
          })
        }
      })
    } else {
      // 数据已返回，真实数据渲染
      this.actualData.forEach((item, index) => {
        renderContent.push(
          this.$scopedSlots.default({
            item,
            index
          })
        )
      })
    }

    if (this.loading === 'more') {
      let loadNode = this.vNode
      // 创建虚拟节点
      if (!loadNode) {
        const vNodeList = this.$scopedSlots.default({
          item: this.itemData
        })
        loadNode = this.handleTreeNodeStyle(vNodeList[0])
      }
      renderContent.push(loadNode)
    }

    return createElement(
      'span', // 标签名称
      renderContent
    )
  },
  methods: {
    // 递归处理需要修改样式的node
    handleTreeNodeStyle(Node) {
      // loadDom 判断是否需要修改样式
      if (
        Node.data &&
        Node.data.attrs &&
        (Node.data.attrs.loadDom === '' || Node.data.attrs.loadDom)
      ) {
        // 如果是图片，设置为指定的加载图片
        if (Node.tag === 'img') {
          Node.data.attrs.src =
            'https://image.ssish.com/core/material/1711449345366.svg'
        }
        // 设置为骨架屏样式
        Node.data.staticClass =
          (Node.data.staticClass || '') +
          (Node.data.staticClass ? ' ' : '') +
          (Node.tag === 'img' ? 'skeleton-img' : 'skeleton-div')
        // 内部文字清空
        if (
          Node.children &&
          Node.children[0] &&
          !Node.children[0].tag &&
          Node.children[0].text
        ) {
          Node.children[0].text = ''
        }
      } else if (Node.children) {
        Node.children = Node.children.map((item) => {
          if (item.tag) {
            return this.handleTreeNodeStyle(item)
          }
          return item
        })
      }
      // 如果传入的是组件（过滤部分vant组件）
      if (
        Node.tag.indexOf('vue-component') > -1 &&
        Node.tag.indexOf('-van-checkbox') === -1
      ) {
        this.$nextTick(() => {
          // 组件节点只有渲染后才能获取内部dom
          this.componentsNode[Node.tag] = this.handleTreeNodeStyle(
            Node.componentInstance._vnode
          )
        })
      }
      return Node
    },
    // 如果节点中存在组件需要重新渲染
    // 递归遍历组件节点替换为之前处理过的内部虚拟dom
    handleComponentsNodes(Node) {
      if (this.componentsNode[Node.tag]) {
        return this.componentsNode[Node.tag]
      } else if (Node.children) {
        Node.children = Node.children.map((item) => {
          return this.handleComponentsNodes(item)
        })
      }
      return Node
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  @keyframes shimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  .skeleton-div,
  .skeleton-img {
    animation-duration: 1.25s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: shimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
    background-size: 800px 104px;
    position: relative;
  }
  .skeleton-div {
    min-height: 14px;
    min-width: 150px;
    margin-bottom: 2px;
    margin-right: 6px;
    width: 100%;
  }
  .skeleton-img {
    position: relative;
    padding: 35%;
    box-sizing: border-box;
  }
}
</style>
